class OrganizationService {
  static getOrgId() {
    return window.organization_id;
  }
}

export default OrganizationService;
